// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountBusinessProfileArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {
  Exact,
  OpenapiAccountBusinessProfileIndustryEnum,
  OpenapiAccountBusinessProfilePaymentCollectionMethodsEnum,
  OpenapiAccountBusinessProfileUrlOptOutReasonEnum,
} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {stripeAddressArkFragment} from './stripeAddressArkFragment';

import type {StripeAddressArkFragmentData} from './stripeAddressArkFragment';

const doc = gql`
  fragment StripeAccountBusinessProfileArkFragment on OpenapiAccountBusinessProfile {
    about_us_url
    cancellation_policy_url
    industry
    annual_revenue {
      amount
      currency
      fiscal_year_end
    }
    estimated_worker_count
    mcc
    mcc_source
    name
    physical_product
    privacy_policy_url
    product_description
    product_pricing_url
    processing_volume_estimate
    refund_policy_url
    monthly_estimated_revenue {
      amount
      currency
    }
    specified_commercial_transactions_act_url
    support_address {
      ...StripeAddressArkFragment
    }
    support_email
    support_phone
    support_url
    terms_of_service_url
    url
    url_opt_out_reason
    payment_collection_methods
  }

  ${stripeAddressArkFragment}
`;

export const stripeAccountBusinessProfileArkFragment: StripeAccountBusinessProfileArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountBusinessProfileArkFragmentData = {
  readonly __typename: 'OpenapiAccountBusinessProfile';
  readonly about_us_url: string | null;
  readonly cancellation_policy_url: string | null;
  readonly industry: OpenapiAccountBusinessProfileIndustryEnum | null;
  readonly estimated_worker_count: number | null;
  readonly mcc: string | null;
  readonly mcc_source: string | null;
  readonly name: string | null;
  readonly physical_product: boolean | null;
  readonly privacy_policy_url: string | null;
  readonly product_description: string | null;
  readonly product_pricing_url: string | null;
  readonly processing_volume_estimate: string | null;
  readonly refund_policy_url: string | null;
  readonly specified_commercial_transactions_act_url: string | null;
  readonly support_email: string | null;
  readonly support_phone: string | null;
  readonly support_url: string | null;
  readonly terms_of_service_url: string | null;
  readonly url: string | null;
  readonly url_opt_out_reason: OpenapiAccountBusinessProfileUrlOptOutReasonEnum | null;
  readonly payment_collection_methods: ReadonlyArray<OpenapiAccountBusinessProfilePaymentCollectionMethodsEnum> | null;
  readonly annual_revenue: {
    readonly __typename: 'OpenapiAccountAnnualRevenue';
    readonly amount: number | null;
    readonly currency: string | null;
    readonly fiscal_year_end: string | null;
  } | null;
  readonly monthly_estimated_revenue: {
    readonly __typename: 'OpenapiAccountMonthlyEstimatedRevenue';
    readonly amount: number;
    readonly currency: string;
  } | null;
  readonly support_address: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAddress'},
    [StripeAddressArkFragmentData]
  > | null;
};

export type StripeAccountBusinessProfileArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountBusinessProfileArkFragmentPermissions = {
  ...stripeAddressArkFragment.permissions,
} as const;

doc.permissions = stripeAccountBusinessProfileArkFragmentPermissions;

export type StripeAccountBusinessProfileArkFragmentPermissions =
  V1PermissionToken<typeof stripeAccountBusinessProfileArkFragmentPermissions>;

export type StripeAccountBusinessProfileArkFragmentDocument = GraphQlDocument<
  StripeAccountBusinessProfileArkFragmentData,
  StripeAccountBusinessProfileArkFragmentVariables,
  StripeAccountBusinessProfileArkFragmentPermissions
>;
